import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-cy": "widget",
      "data-cy-widget-id": _vm.widget.id,
      "data-cy-is-loading": _vm.isLoading ? 'true' : 'false'
    }
  }, [!_vm.hidden ? _c(VCard, {
    style: `height: 100%; display: flex; flex-direction: column; ${_vm.widget.type !== 'twin-table' && _vm.widget.minHeightPx === undefined ? '' : `min-height: ${_vm.widget.minHeightPx}px;`}`
  }, [_vm.someStatesLimitReached ? _c(VSystemBar, {
    attrs: {
      "height": "auto",
      "color": "warning"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('Dashboards.components.chart.limitReached.text', {
    limit: _vm.someStatesLimitReached
  })) + "\n    ")]) : _vm._e(), _vm.showHeader ? _c(VCardTitle, {
    class: {
      header: true
    },
    staticStyle: {
      "font-size": "14px",
      "letter-spacing": "unset",
      "padding-block": "0"
    }
  }, [_c(VRow, {
    staticStyle: {
      "padding-block": "0",
      "align-items": "center",
      "width": "100%"
    }
  }, [_c(VCol, {
    staticStyle: {
      "min-width": "0"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "max-width": "100%",
      "overflow": "hidden",
      "text-overflow": "ellipsis",
      "white-space": "nowrap"
    },
    attrs: {
      "title": _vm.cardTitle
    }
  }, [_vm._v("\n            " + _vm._s(_vm.cardTitle) + "\n          ")])]), _c(VCol, {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.widget.type !== 'empty' ? _c(VTooltip, {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function ({
        on,
        attrs
      }) {
        return [_c(VBtn, _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "small": "",
            "loading": _vm.isLoading,
            "color": _vm.color,
            "data-cy": "refresh-btn"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('refresh-data');
            }
          }
        }, 'v-btn', attrs, false), on), [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-rotate")])], 1)];
      }
    }], null, false, 2758707899)
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.$t('Dashboards.components.widgetCard.button.refreshData')) + "\n            ")])]) : _vm._e(), _vm.editMode ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": "",
      "loading": _vm.isDeleting,
      "color": _vm.color,
      "data-cy": "delete-btn"
    },
    on: {
      "click": _vm.removeWidget
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-trash")])], 1) : _vm._e(), _vm.editMode ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": "",
      "color": _vm.color,
      "data-cy": "settings-btn"
    },
    on: {
      "click": function ($event) {
        _vm.showEditWidgetDialog = true;
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-cog")])], 1) : _vm._e(), _vm.editMode ? _c(VBtn, {
    staticClass: "handle",
    staticStyle: {
      "cursor": "grab"
    },
    attrs: {
      "icon": "",
      "small": "",
      "color": _vm.color,
      "data-cy": "drag-btn"
    }
  }, [_c(VIcon, [_vm._v("fal fa-grip-vertical")])], 1) : _vm._e(), _vm.$listeners['show-in-full-screen'] && _vm.widget.type !== 'empty' ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": "",
      "color": _vm.color,
      "data-cy": "expand-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('show-in-full-screen');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-expand")])], 1) : _vm._e(), _vm.$listeners['close-full-screen'] ? _c(VBtn, {
    attrs: {
      "icon": "",
      "small": "",
      "color": _vm.color,
      "data-cy": "close-expanded-btn"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close-full-screen');
      }
    }
  }, [_c(VIcon, {
    attrs: {
      "small": ""
    }
  }, [_vm._v("fal fa-close")])], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm.dataSet.success === false ? _c(VCardText, [_c(VAlert, {
    staticClass: "text-center",
    attrs: {
      "type": "error"
    }
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.$t('Dashboards.components.widgetCard.alert.couldNotLoadData', {
    widgetId: _vm.widget.id
  })) + "\n        ")]), _c('br'), _c('br'), _c('small', [_vm._v(_vm._s(_vm.dataSet.error))])])], 1) : _vm._e(), _c(_vm.widget.borderless ? 'div' : 'v-card-text', {
    tag: "component",
    class: {
      content: true,
      withHeader: _vm.showHeader,
      borderless: _vm.widget.borderless
    },
    staticStyle: {
      "flex": "1",
      "min-height": "unset"
    }
  }, [_vm.widget.type === 'chart' ? _c('chart', {
    attrs: {
      "widget": _vm.widget,
      "data": _vm.dataSet.data,
      "date-range": _vm.dateRange,
      "display-as-json": _vm.displayAsJson
    }
  }) : _vm.widget.type === 'twin-table' ? _c('twin-table', {
    attrs: {
      "widget": _vm.widget,
      "loading": !_vm.dataSet,
      "data": _vm.dataSet.data,
      "date-range": _vm.dateRange,
      "edit-mode": _vm.editMode,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "activate-sub-dashboard": function ($event) {
        return _vm.$emit('activate-sub-dashboard', $event);
      }
    }
  }) : _vm.widget.type === 'twin-map' ? _c('twin-map', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "widget": _vm.widget,
      "data": _vm.dataSet.data,
      "padding-top": _vm.mapPaddingTop,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "click:action": _vm.onActionClick
    }
  }) : _vm._e()], 1), _c(VOverlay, {
    attrs: {
      "absolute": "",
      "value": _vm.isLoading
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "indeterminate": "",
      "size": "64"
    }
  })], 1)], 1) : _vm._e(), _c('widget-edit-dialog', {
    attrs: {
      "dashboard-id": _vm.dashboardId,
      "widget-id": _vm.widget.id,
      "date-range": _vm.dateRange,
      "custom-parameters": _vm.customParameters
    },
    on: {
      "saved": function ($event) {
        _vm.showEditWidgetDialog = false;
      },
      "close": function ($event) {
        _vm.showEditWidgetDialog = false;
      }
    },
    model: {
      value: _vm.showEditWidgetDialog,
      callback: function ($$v) {
        _vm.showEditWidgetDialog = $$v;
      },
      expression: "showEditWidgetDialog"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };